import validate from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@4.4.7_@babel+plugin-syntax-jsx@7.27.1_@babel+core@7.29.7__@babel+plugin-syntax-typ_0c8c5a4e9e9cd6ee66ba4a6aa9082718/node_modules/nuxt/dist/pages/runtime/validate.js";
import refresh_45session_45global from "/builds/void-zero/clients/mijn-epd/app/middleware/refresh-session.global.ts";
import manifest_45route_45rule from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@4.4.7_@babel+plugin-syntax-jsx@7.27.1_@babel+core@7.29.7__@babel+plugin-syntax-typ_0c8c5a4e9e9cd6ee66ba4a6aa9082718/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  refresh_45session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/void-zero/clients/mijn-epd/app/middleware/auth.ts")
}